import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import PropTypes from "prop-types";
import { Redirect, withRouter } from "react-router-dom";
import { ERROR_MSG, PATHS, STATUS } from "../../constant";
import {
  userLogin,
  userLoginRequest,
  userSecurityKey
} from "../../actions/login.action";
import {
  getProjectList,
  getPermissionsAction
} from "../../actions/common.action";
import { getLocalstorage } from "../../helper";
import { Form, Button } from "react-bootstrap";
import cookieService from "../../services/cookieService";
import { LoaderPage } from "../../component/Loader";
import RegistrationOtp from "./RegistrationOtp";
import { DEFAULT_VALIDATION } from "../../validation";
import { sendSignUpOtp } from "../../actions/signup.action";
import { sendVerificationOTP } from "../../actions/login.action";
import { toast } from "react-toastify";
import { get } from "lodash";
import ReCaptcha from "../GoogleCaptcha/googleCaptcha";
import { JSEncrypt } from "jsencrypt";
import { successToastStyle, errorToastStyle } from "../../customToast";
class LoginForm extends Component {
  constructor(props) {
    super(props);
    const loginFormData = cookieService.getCookie(
      this.props.cookies,
      "loginFormUserInfo"
    );
    this.state = {
      username: (loginFormData && loginFormData.username) || "",
      password: (loginFormData && loginFormData.password) || "",
      errors: {},
      type: "password",
      submitBtnText: "Login",
      redirectToReferrer: !!getLocalstorage("token"),
      isRememberMe: (loginFormData && loginFormData.isRememberMe) || false,
      show: false,
      captchaToken: null,
      data: {},
      result: {},
      encryptedPassword: "",
      disable: false
    };
  }

  handleCheckbox = () => {
    const { isRememberMe } = this.state;
    this.setState({
      isRememberMe: !isRememberMe
    });
  };

  handleChange = event => {
    const { name, value } = event.target;
    this.setState({ [name]: value });
  };

  showPassword = e => {
    e.preventDefault();
    e.stopPropagation();
    const { type } = this.state;
    this.setState({
      type: type === "password" ? "input" : "password"
    });
  };

  validateField = (fieldName, value) => {
    let { errors, password, username } = this.state;
    switch (fieldName) {
      case "username":
        this.handleUsername();
        break;
      case "password":
        errors.passwordValid = DEFAULT_VALIDATION(value, "Password");
        break;
      default:
        errors.passwordValid = DEFAULT_VALIDATION(password, "Password");
        errors.usernameValid = DEFAULT_VALIDATION(username, "Username");
        break;
    }
    this.setState({
      errors: errors
    });
  };

  handleUsername = async () => {
    const { username, errors } = this.state;
    const { userLoginRequest } = this.props;
    errors.usernameValid = DEFAULT_VALIDATION(username.trim(), "Username");
    this.setState({
      errors: errors
    });
    const payload = {
      loginType: "PASSWORD",
      userId: username.trim()
    };
    if (username.trim() == "") {
      return;
    }
    try {
      await userLoginRequest(payload);
      const { loginRequestData } = this.props;
      const usernameValid = loginRequestData && loginRequestData.status;
      if (loginRequestData.status) {
        this.setState({
          errors: {
            ...this.state.errors,
            usernameValid: {
              error: false,
              message: ""
            }
          }
        });
      } else {
        this.setState({
          errors: {
            ...this.state.errors,
            usernameValid: {
              error: true,
              message: loginRequestData.message || loginRequestData.error
            }
          }
        });
      }
    } catch (e) {
      console.log(`Error in login ${e.message}`);
      this.setState({
        errors: {
          ...this.state.errors,
          usernameValid: {
            error: true,
            message: "Invalid username or email"
          }
        }
      });
    }
  };

  validateForm = () => {
    let { errors } = this.state;
    let { passwordValid } = errors;
    return passwordValid.error !== undefined && !passwordValid.error;
  };

  getSecurityKey = async () => {
    const { captchaToken, password } = this.state;
    const { userSecurityKey } = this.props;
    try {
      await userSecurityKey();
      const { securityKeyData, history } = this.props;
      if (get(securityKeyData, "id")) {
        let userID = get(securityKeyData, "id");
        const encrypt = new JSEncrypt();
        encrypt.setPublicKey(get(securityKeyData, "key"));
        const encryptedPassword = encrypt.encrypt(password);
        this.setState({ encryptedPassword, userID, password });
        this.handleUsername();
        this.submitLoginForm();
      } else {
        toast.error(
          <p className="toast-text-alignment">Please check your credentials</p>,
          errorToastStyle
        );
        history.push(PATHS.LOGIN);
      }
      this.captchaElement &&
        this.captchaElement.reset(this.captchaElementResetId);
    } catch (e) {
      console.log(`Error in login ${e.message}`);
      this.captchaElement &&
        this.captchaElement.reset(this.captchaElementResetId);
    }
  };

  submitLoginForm = async () => {
    const {
      userID,
      isRememberMe,
      captchaToken,
      password,
      encryptedPassword,
      username,
      errors
    } = this.state;
    if (username == "" || password == "") {
      return;
    }
    const { userLogin, cookies, getPermissionsDispatch } = this.props;
    const userId = getLocalstorage("userId");
    const loginInfo = {
      // username: userId,
      username: username.trim(),
      encryptedPassword,
      isRememberMe,
      userID
    };
    // this.validateField();
    // let isValidData = this.validateForm();
    // if (isValidData) {
    try {
      //loginInfo.googleCaptchaToken = captchaToken;
      await userLogin(undefined, loginInfo, cookies);
      const { loginResult, history } = this.props;
      if (get(loginResult, "status")) {
        const userData = get(loginResult, "data.user", {});
        // if (!get(userData, "verified")) {
        //   const result = {
        //     data: {
        //       id: get(userData, "id")
        //     },
        //     status: get(loginResult, "status")
        //   };
        //   const data = {
        //     mobileNumber: get(userData, "mobileNumber"),
        //     email: get(userData, "email"),
        //     userID: userId,
        //     password
        //   };
        //   this.handleShow(data, result);
        // } else {
        toast.success(
          <p className="toast-text-alignment">{get(loginResult, "message")}</p>,
          successToastStyle
        );
        this.setState({ isPermissionLoading: STATUS.LOADING }, async () => {
          const resp = await getPermissionsDispatch();
          if (resp) {
            const projectCreated = get(userData, "projectCreatedBy");
            projectCreated
              ? history.push(PATHS.DASHBOARD)
              : history.push(PATHS.CREATE_PROJECT);
            this.setState({ isPermissionLoading: STATUS.SUCCESS });
          }
        });
        // }
      } else {
        this.setState({ disable: false });
        errors.passwordValid = {
          error: true,
          message: "Invalid Password"
        };
        this.setState({ errors: errors });
        toast.error(
          <p className="toast-text-alignment">Please check your credentials</p>,
          errorToastStyle
        );
        history.push(PATHS.LOGIN);
      }
      this.captchaElement &&
        this.captchaElement.reset(this.captchaElementResetId);
    } catch (e) {
      console.log(`Error in login ${e.message}`);
      this.captchaElement &&
        this.captchaElement.reset(this.captchaElementResetId);
    }
    //}
  };

  handleClose = () => {
    this.setState({ show: false });
  };

  disableHandler = () => {
    this.setState({ disable: true });
  };

  handleShow = async (data, result) => {
    this.setState({
      show: false,
      data: data,
      result: result,
      isSendForVerification: true
    });
    data.loginOtp = true;
    if (data) {
      let otpResult = await sendVerificationOTP(undefined, {
        email: data.email,
        service: "VERIFIED",
        mobileNumber: data.mobileNumber,
        userId: result && result.data.id
      });
      if (otpResult && otpResult.data.status) {
        toast.success(
          <p className="toast-text-alignment">
            {get(otpResult, "data.message")}
          </p>,
          successToastStyle
        );
      } else if (otpResult && !otpResult.data.status) {
        toast.error(
          <p className="toast-text-alignment">
            {get(otpResult, "data.message")}
          </p>,
          errorToastStyle
        );
      }
      this.setState({
        show: true,
        isSendForVerification: false
      });
    }
  };

  changePhone = value => {
    this.setState({ mobileNumber: value });
  };

  changeEmail = value => {
    this.setState({ email: value });
  };

  onCaptchaResolved = captchaToken => {
    this.setState({ captchaToken });
    this.disableHandler();
    (captchaToken && this.getSecurityKey()) ||
      toast.error(
        <p className="toast-text-alignment">{ERROR_MSG.INVALID_CAPTCHA}</p>,
        errorToastStyle
      );
  };

  onValidateCaptcha = e => {
    e.preventDefault();
    this.validateField();
    let isValidData = this.validateForm();
    if (isValidData && this.captchaElement) {
      this.captchaElement.execute(this.captchaElementResetId);
    }
  };

  render() {
    const {
      username,
      password,
      errors,
      type,
      submitBtnText,
      isRememberMe,
      redirectToReferrer,
      show,
      data,
      isSendForVerification,
      isPermissionLoading,
      result,
      disable
    } = this.state;
    const { handleForget, location, loading, loginRequestData } = this.props;
    const { from } = location.state || { from: { pathname: PATHS.DASHBOARD } };
    if (redirectToReferrer) return <Redirect to={from} />;
    // if (loginRequestData && !loginRequestData.status)
    // return <Redirect to={PATHS.LOGIN} />;
    return (
      <div className="register-inner">
        <LoaderPage
          loading={
            loading === STATUS.LOADING ||
            isPermissionLoading === STATUS.LOADING ||
            isSendForVerification
          }
        />
        <h1 className="page-heading hide-heading">Login</h1>
        {/* <p className="page-sub-heading first-sub-heading" data-test="user-name">
          Hi, {loginRequestData && loginRequestData.data}
        </p>
        <p className="page-sub-heading second-sub-heading">
          Please Enter Your Password
        </p> */}
        <Form className="signin-form" onSubmit={this.onValidateCaptcha}>
          <Form.Group controlId="username">
            <Form.Label>Username or Email</Form.Label>
            <Form.Control
              type="text"
              name="username"
              value={username}
              onChange={this.handleChange}
              onBlur={() => this.validateField("username", username)}
              isInvalid={errors.usernameValid && errors.usernameValid.error}
            />
            <Form.Control.Feedback type="invalid">
              {errors.usernameValid && errors.usernameValid.error
                ? errors.usernameValid.message
                : null}
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group controlId="password">
            <Form.Label>Password</Form.Label>
            <Form.Control
              type={type}
              name="password"
              value={password}
              onChange={this.handleChange}
              onBlur={() => this.validateField("password", password)}
              isInvalid={errors.passwordValid && errors.passwordValid.error}
            />
            <span
              role="presentation"
              className={`eye_icon ${type === "password" ? "eye_hide" : ""}`}
              onClick={this.showPassword}
            />
            <Form.Control.Feedback type="invalid">
              {errors.passwordValid && errors.passwordValid.error
                ? errors.passwordValid.message
                : null}
            </Form.Control.Feedback>
          </Form.Group>
          <div className="remember-forget-box">
            <Form.Group controlId="checkbox">
              <Form.Check
                className={
                  isRememberMe ? "form-checkbox checked" : "form-checkbox"
                }
              >
                <Form.Check.Input
                  type="checkbox"
                  name="tc"
                  value={isRememberMe}
                  onClick={this.handleCheckbox}
                />
                <Form.Check.Label style={{ width: "130px" }}>
                  <span>Remember Me</span>
                </Form.Check.Label>
              </Form.Check>
            </Form.Group>
            <span className="forgetLink" onClick={handleForget}>
              Forgot Password?
            </span>
          </div>
          <Button
            variant="primary"
            type="submit"
            data-test={submitBtnText + "-button"}
            // className="btn-orange full-width"
            className={`btn-orange full-width ${disable ? "btn-disable" : " "}`}
            disabled={disable}
            onClick={() => this.getSecurityKey()}
          >
            {submitBtnText}
          </Button>
        </Form>
        <RegistrationOtp
          show={show}
          handleClose={this.handleClose}
          changePhone={this.changePhone}
          changeEmail={this.changeEmail}
          data={data}
          result={result}
        />
        {/* <ReCaptcha
          id="recaptcha"
          getRef={ref => {
            this.captchaElement = ref;
          }}
          onChange={this.onCaptchaResolved}
          resetId={id => {
            this.captchaElementResetId = id;
          }}
        /> */}
      </div>
    );
  }
}

LoginForm.propTypes = {
  history: PropTypes.shape({}),
  location: PropTypes.shape({})
};

LoginForm.defaultProps = {
  history: {},
  location: {}
};

function mapStateToProps(state) {
  return {
    loginResult: state.loginReducer.data,
    loginRequestData: state.loginReducer.loginRequestData,
    securityKeyData: state.loginReducer.securityKeyData,
    loading: state.loginReducer.loginStatus,
    projectList: state.commonReducer.projectList
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      userLogin: userLogin,
      getProjectList: getProjectList,
      sendSignUpOtp: sendSignUpOtp,
      getPermissionsDispatch: getPermissionsAction,
      userSecurityKey,
      userLoginRequest
    },
    dispatch
  );
}

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(LoginForm)
);
